/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.StateProvince_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.StateProvince domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum StateProvince_ {
   /// <summary>
   ///    ()
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Alaska (AK)
   /// </summary>
   AK = 1,
   /// <summary>
   ///   Alabama (AL)
   /// </summary>
   AL = 2,
   /// <summary>
   ///   Arkansas (AR)
   /// </summary>
   AR = 3,
   /// <summary>
   ///   Arizona (AZ)
   /// </summary>
   AZ = 4,
   /// <summary>
   ///   California (CA)
   /// </summary>
   CA = 5,
   /// <summary>
   ///   Colorado (CO)
   /// </summary>
   CO = 6,
   /// <summary>
   ///   Connecticut (CT)
   /// </summary>
   CT = 7,
   /// <summary>
   ///   District Of Columbia (DC)
   /// </summary>
   DC = 8,
   /// <summary>
   ///   Delaware (DE)
   /// </summary>
   DE = 9,
   /// <summary>
   ///   Florida (FL)
   /// </summary>
   FL = 10,
   /// <summary>
   ///   Georgia (GA)
   /// </summary>
   GA = 11,
   /// <summary>
   ///   Hawaii (HI)
   /// </summary>
   HI = 12,
   /// <summary>
   ///   Iowa (IA)
   /// </summary>
   IA = 13,
   /// <summary>
   ///   Idaho (ID)
   /// </summary>
   ID = 14,
   /// <summary>
   ///   Illinois (IL)
   /// </summary>
   IL = 15,
   /// <summary>
   ///   Indiana (IN)
   /// </summary>
   IN = 16,
   /// <summary>
   ///   Kansas (KS)
   /// </summary>
   KS = 17,
   /// <summary>
   ///   Kentucky (KY)
   /// </summary>
   KY = 18,
   /// <summary>
   ///   Louisiana (LA)
   /// </summary>
   LA = 19,
   /// <summary>
   ///   Massachusetts (MA)
   /// </summary>
   MA = 20,
   /// <summary>
   ///   Maryland (MD)
   /// </summary>
   MD = 21,
   /// <summary>
   ///   Maine (ME)
   /// </summary>
   ME = 22,
   /// <summary>
   ///   Michigan (MI)
   /// </summary>
   MI = 23,
   /// <summary>
   ///   Minnesota (MN)
   /// </summary>
   MN = 24,
   /// <summary>
   ///   Missouri (MO)
   /// </summary>
   MO = 25,
   /// <summary>
   ///   Mississippi (MS)
   /// </summary>
   MS = 26,
   /// <summary>
   ///   Montana (MT)
   /// </summary>
   MT = 27,
   /// <summary>
   ///   North Carolina (NC)
   /// </summary>
   NC = 28,
   /// <summary>
   ///   North Dakota (ND)
   /// </summary>
   ND = 29,
   /// <summary>
   ///   Nebraska (NE)
   /// </summary>
   NE = 30,
   /// <summary>
   ///   New Hampshire (NH)
   /// </summary>
   NH = 31,
   /// <summary>
   ///   New Jersey (NJ)
   /// </summary>
   NJ = 32,
   /// <summary>
   ///   New Mexico (NM)
   /// </summary>
   NM = 33,
   /// <summary>
   ///   Nevada (NV)
   /// </summary>
   NV = 34,
   /// <summary>
   ///   New York (NY)
   /// </summary>
   NY = 35,
   /// <summary>
   ///   Ohio (OH)
   /// </summary>
   OH = 36,
   /// <summary>
   ///   Oklahoma (OK)
   /// </summary>
   OK = 37,
   /// <summary>
   ///   Oregon (OR)
   /// </summary>
   OR = 38,
   /// <summary>
   ///   Pennsylvania (PA)
   /// </summary>
   PA = 39,
   /// <summary>
   ///   Puerto Rico (PR)
   /// </summary>
   PR = 40,
   /// <summary>
   ///   Rhode Island (RI)
   /// </summary>
   RI = 41,
   /// <summary>
   ///   South Carolina (SC)
   /// </summary>
   SC = 42,
   /// <summary>
   ///   South Dakota (SD)
   /// </summary>
   SD = 43,
   /// <summary>
   ///   Tennessee (TN)
   /// </summary>
   TN = 44,
   /// <summary>
   ///   Texas (TX)
   /// </summary>
   TX = 45,
   /// <summary>
   ///   Utah (UT)
   /// </summary>
   UT = 46,
   /// <summary>
   ///   Virginia (VA)
   /// </summary>
   VA = 47,
   /// <summary>
   ///   Vermont (VT)
   /// </summary>
   VT = 48,
   /// <summary>
   ///   Washington (WA)
   /// </summary>
   WA = 49,
   /// <summary>
   ///   Wisconsin (WI)
   /// </summary>
   WI = 50,
   /// <summary>
   ///   West Virginia (WV)
   /// </summary>
   WV = 51,
   /// <summary>
   ///   Wyoming (WY)
   /// </summary>
   WY = 52
}

export const StateProvinces: StateProvince[] = [
   {
      code: StateProvince_.Unknown,
      literal: 'Unknown',
      description: '',
      shortDescription: '',
      listPriority: 0,

      standardCode: '',

      name: '',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AK,
      literal: 'AK',
      description: 'Alaska',
      shortDescription: 'AK',
      listPriority: 0,

      standardCode: 'AK',

      name: 'Alaska',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AL,
      literal: 'AL',
      description: 'Alabama',
      shortDescription: 'AL',
      listPriority: 0,

      standardCode: 'AL',

      name: 'Alabama',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AR,
      literal: 'AR',
      description: 'Arkansas',
      shortDescription: 'AR',
      listPriority: 0,

      standardCode: 'AR',

      name: 'Arkansas',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.AZ,
      literal: 'AZ',
      description: 'Arizona',
      shortDescription: 'AZ',
      listPriority: 0,

      standardCode: 'AZ',

      name: 'Arizona',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CA,
      literal: 'CA',
      description: 'California',
      shortDescription: 'CA',
      listPriority: 0,

      standardCode: 'CA',

      name: 'California',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CO,
      literal: 'CO',
      description: 'Colorado',
      shortDescription: 'CO',
      listPriority: 0,

      standardCode: 'CO',

      name: 'Colorado',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.CT,
      literal: 'CT',
      description: 'Connecticut',
      shortDescription: 'CT',
      listPriority: 0,

      standardCode: 'CT',

      name: 'Connecticut',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DC,
      literal: 'DC',
      description: 'District Of Columbia',
      shortDescription: 'DC',
      listPriority: 0,

      standardCode: 'DC',

      name: 'District Of Columbia',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.DE,
      literal: 'DE',
      description: 'Delaware',
      shortDescription: 'DE',
      listPriority: 0,

      standardCode: 'DE',

      name: 'Delaware',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.FL,
      literal: 'FL',
      description: 'Florida',
      shortDescription: 'FL',
      listPriority: 0,

      standardCode: 'FL',

      name: 'Florida',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.GA,
      literal: 'GA',
      description: 'Georgia',
      shortDescription: 'GA',
      listPriority: 0,

      standardCode: 'GA',

      name: 'Georgia',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.HI,
      literal: 'HI',
      description: 'Hawaii',
      shortDescription: 'HI',
      listPriority: 0,

      standardCode: 'HI',

      name: 'Hawaii',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IA,
      literal: 'IA',
      description: 'Iowa',
      shortDescription: 'IA',
      listPriority: 0,

      standardCode: 'IA',

      name: 'Iowa',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ID,
      literal: 'ID',
      description: 'Idaho',
      shortDescription: 'ID',
      listPriority: 0,

      standardCode: 'ID',

      name: 'Idaho',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IL,
      literal: 'IL',
      description: 'Illinois',
      shortDescription: 'IL',
      listPriority: 0,

      standardCode: 'IL',

      name: 'Illinois',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.IN,
      literal: 'IN',
      description: 'Indiana',
      shortDescription: 'IN',
      listPriority: 0,

      standardCode: 'IN',

      name: 'Indiana',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KS,
      literal: 'KS',
      description: 'Kansas',
      shortDescription: 'KS',
      listPriority: 0,

      standardCode: 'KS',

      name: 'Kansas',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.KY,
      literal: 'KY',
      description: 'Kentucky',
      shortDescription: 'KY',
      listPriority: 0,

      standardCode: 'KY',

      name: 'Kentucky',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.LA,
      literal: 'LA',
      description: 'Louisiana',
      shortDescription: 'LA',
      listPriority: 0,

      standardCode: 'LA',

      name: 'Louisiana',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MA,
      literal: 'MA',
      description: 'Massachusetts',
      shortDescription: 'MA',
      listPriority: 0,

      standardCode: 'MA',

      name: 'Massachusetts',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MD,
      literal: 'MD',
      description: 'Maryland',
      shortDescription: 'MD',
      listPriority: 0,

      standardCode: 'MD',

      name: 'Maryland',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ME,
      literal: 'ME',
      description: 'Maine',
      shortDescription: 'ME',
      listPriority: 0,

      standardCode: 'ME',

      name: 'Maine',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MI,
      literal: 'MI',
      description: 'Michigan',
      shortDescription: 'MI',
      listPriority: 0,

      standardCode: 'MI',

      name: 'Michigan',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MN,
      literal: 'MN',
      description: 'Minnesota',
      shortDescription: 'MN',
      listPriority: 0,

      standardCode: 'MN',

      name: 'Minnesota',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MO,
      literal: 'MO',
      description: 'Missouri',
      shortDescription: 'MO',
      listPriority: 0,

      standardCode: 'MO',

      name: 'Missouri',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MS,
      literal: 'MS',
      description: 'Mississippi',
      shortDescription: 'MS',
      listPriority: 0,

      standardCode: 'MS',

      name: 'Mississippi',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.MT,
      literal: 'MT',
      description: 'Montana',
      shortDescription: 'MT',
      listPriority: 0,

      standardCode: 'MT',

      name: 'Montana',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NC,
      literal: 'NC',
      description: 'North Carolina',
      shortDescription: 'NC',
      listPriority: 0,

      standardCode: 'NC',

      name: 'North Carolina',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.ND,
      literal: 'ND',
      description: 'North Dakota',
      shortDescription: 'ND',
      listPriority: 0,

      standardCode: 'ND',

      name: 'North Dakota',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NE,
      literal: 'NE',
      description: 'Nebraska',
      shortDescription: 'NE',
      listPriority: 0,

      standardCode: 'NE',

      name: 'Nebraska',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NH,
      literal: 'NH',
      description: 'New Hampshire',
      shortDescription: 'NH',
      listPriority: 0,

      standardCode: 'NH',

      name: 'New Hampshire',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NJ,
      literal: 'NJ',
      description: 'New Jersey',
      shortDescription: 'NJ',
      listPriority: 0,

      standardCode: 'NJ',

      name: 'New Jersey',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NM,
      literal: 'NM',
      description: 'New Mexico',
      shortDescription: 'NM',
      listPriority: 0,

      standardCode: 'NM',

      name: 'New Mexico',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NV,
      literal: 'NV',
      description: 'Nevada',
      shortDescription: 'NV',
      listPriority: 0,

      standardCode: 'NV',

      name: 'Nevada',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.NY,
      literal: 'NY',
      description: 'New York',
      shortDescription: 'NY',
      listPriority: 0,

      standardCode: 'NY',

      name: 'New York',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OH,
      literal: 'OH',
      description: 'Ohio',
      shortDescription: 'OH',
      listPriority: 0,

      standardCode: 'OH',

      name: 'Ohio',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OK,
      literal: 'OK',
      description: 'Oklahoma',
      shortDescription: 'OK',
      listPriority: 0,

      standardCode: 'OK',

      name: 'Oklahoma',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.OR,
      literal: 'OR',
      description: 'Oregon',
      shortDescription: 'OR',
      listPriority: 0,

      standardCode: 'OR',

      name: 'Oregon',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PA,
      literal: 'PA',
      description: 'Pennsylvania',
      shortDescription: 'PA',
      listPriority: 0,

      standardCode: 'PA',

      name: 'Pennsylvania',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.PR,
      literal: 'PR',
      description: 'Puerto Rico',
      shortDescription: 'PR',
      listPriority: 0,

      standardCode: 'PR',

      name: 'Puerto Rico',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.RI,
      literal: 'RI',
      description: 'Rhode Island',
      shortDescription: 'RI',
      listPriority: 0,

      standardCode: 'RI',

      name: 'Rhode Island',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SC,
      literal: 'SC',
      description: 'South Carolina',
      shortDescription: 'SC',
      listPriority: 0,

      standardCode: 'SC',

      name: 'South Carolina',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.SD,
      literal: 'SD',
      description: 'South Dakota',
      shortDescription: 'SD',
      listPriority: 0,

      standardCode: 'SD',

      name: 'South Dakota',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TN,
      literal: 'TN',
      description: 'Tennessee',
      shortDescription: 'TN',
      listPriority: 0,

      standardCode: 'TN',

      name: 'Tennessee',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.TX,
      literal: 'TX',
      description: 'Texas',
      shortDescription: 'TX',
      listPriority: 0,

      standardCode: 'TX',

      name: 'Texas',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.UT,
      literal: 'UT',
      description: 'Utah',
      shortDescription: 'UT',
      listPriority: 0,

      standardCode: 'UT',

      name: 'Utah',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VA,
      literal: 'VA',
      description: 'Virginia',
      shortDescription: 'VA',
      listPriority: 0,

      standardCode: 'VA',

      name: 'Virginia',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.VT,
      literal: 'VT',
      description: 'Vermont',
      shortDescription: 'VT',
      listPriority: 0,

      standardCode: 'VT',

      name: 'Vermont',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WA,
      literal: 'WA',
      description: 'Washington',
      shortDescription: 'WA',
      listPriority: 0,

      standardCode: 'WA',

      name: 'Washington',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WI,
      literal: 'WI',
      description: 'Wisconsin',
      shortDescription: 'WI',
      listPriority: 0,

      standardCode: 'WI',

      name: 'Wisconsin',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WV,
      literal: 'WV',
      description: 'West Virginia',
      shortDescription: 'WV',
      listPriority: 0,

      standardCode: 'WV',

      name: 'West Virginia',

      typeName: "StateProvince"
   },
   {
      code: StateProvince_.WY,
      literal: 'WY',
      description: 'Wyoming',
      shortDescription: 'WY',
      listPriority: 0,

      standardCode: 'WY',

      name: 'Wyoming',

      typeName: "StateProvince"
   }
]

export class StateProvince implements IDomainModel {
   code: StateProvince_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   standardCode: string

   name: string

   typeName: string

   static toDomainModel(code: StateProvince_): StateProvince {
      return StateProvinces.find(d => d.code === code)
   }
}
